module.exports = __webpack_public_path__ + "assets/img/btn-view-47bd4cfb.png";